var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6633 0.32959H1.9127C0.921065 0.32959 0.117188 1.13347 0.117188 2.1251V21.8757C0.117188 22.8674 0.921065 23.6712 1.9127 23.6712H21.6633C22.655 23.6712 23.4588 22.8674 23.4588 21.8757V2.1251C23.4588 1.13347 22.655 0.32959 21.6633 0.32959ZM21.6633 21.8757H1.9127V2.1251H21.6633V21.8757ZM8.19699 10.2049V17.3869C8.19699 17.8828 7.79505 18.2847 7.29923 18.2847C6.80342 18.2847 6.40148 17.8828 6.40148 17.3869V10.2049C6.40148 9.70908 6.80342 9.30715 7.29923 9.30715C7.79505 9.30715 8.19699 9.70908 8.19699 10.2049ZM18.0723 13.347V17.3869C18.0723 17.8828 17.6704 18.2847 17.1745 18.2847C16.6787 18.2847 16.2768 17.8828 16.2768 17.3869V13.347C16.2768 12.1075 15.2719 11.1027 14.0324 11.1027C12.7929 11.1027 11.788 12.1075 11.788 13.347V17.3869C11.788 17.8828 11.3861 18.2847 10.8903 18.2847C10.3944 18.2847 9.9925 17.8828 9.9925 17.3869V10.2049C9.9948 9.74974 10.3374 9.36833 10.7897 9.31734C11.242 9.26635 11.6609 9.56193 11.7644 10.0052C13.002 9.16559 14.6022 9.07841 15.9237 9.77853C17.2452 10.4787 18.0718 11.8515 18.0723 13.347ZM8.64587 7.06276C8.64587 7.80648 8.04296 8.40939 7.29923 8.40939C6.55551 8.40939 5.9526 7.80648 5.9526 7.06276C5.9526 6.31903 6.55551 5.71612 7.29923 5.71612C8.04296 5.71612 8.64587 6.31903 8.64587 7.06276Z",
    fill: "#99A8C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedinLogo.f21d2462fdb90e751f2a5682a8588624.svg";
export { ForwardRef as ReactComponent };